import { apiRequest } from '../../services/apiClient';

// Counterparty 360 (doc-174). Entities have no table — the backend folds
// contract counterparties, aliases, counterparty_group and TPRM vendor names
// into one entity per relationship and hands back a canonical key ('c:<slug>'
// for a counterparty, 'g:<slug>' for a group).
//
// Link sites only ever have the raw counterparty STRING, so they link through
// the 'n:<name>' form and let the backend resolve it with the same normalizer
// (the page then swaps the URL for the canonical key it gets back). That keeps
// the normalizer in exactly one place — the backend.

export function counterpartyPath(key) {
  return `/counterparties/${encodeURIComponent(key)}`;
}

export function counterpartyPathForName(name) {
  return counterpartyPath(`n:${String(name || '').trim()}`);
}

export function fetchCounterparties({ q, kind, sort, page, pageSize, hasOpenRequests } = {}) {
  const params = new URLSearchParams();
  if (q && q.trim()) params.set('q', q.trim());
  if (kind) params.set('kind', kind);
  if (sort) params.set('sort', sort);
  if (hasOpenRequests) params.set('hasOpenRequests', 'true');
  if (page) params.set('page', String(page));
  if (pageSize) params.set('pageSize', String(pageSize));
  const query = params.toString();
  return apiRequest(`/counterparties${query ? `?${query}` : ''}`);
}

export function fetchCounterparty(key) {
  return apiRequest(`/counterparties/${encodeURIComponent(key)}`);
}
